import React, { Component } from "react";

export class FileImporter extends Component {
    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();

        this.onFileChange = this.onFileChange.bind(this);
        this.handleFileLoad = this.handleFileLoad.bind(this);
    }

    openFileDialog() {
        if (this.fileInputRef.current) {
            this.fileInputRef.current.value = ""; 
            this.fileInputRef.current.click();
        }
    }

    onFileChange(event) {
        const file = event.target.files[0];

        if (!file) {
            return;  
        } 

        const reader = new FileReader();
        reader.onload = this.handleFileLoad;
        reader.readAsText(file);
    }

    handleFileLoad(e) {
        try {
            const json = JSON.parse(e.target.result);

            if (this.props.onFileLoaded) {
                this.props.onFileLoaded(json);
            }
        } catch (err) {
            if (this.props.onError) {
                this.props.onError(err);
            }
        }
    }

    render() {
        return (
            <input
                type="file"
                accept=".ipubschematicconfig"
                style={{ display: "none" }}
                ref={this.fileInputRef}
                onChange={this.onFileChange}
            />
        );
    }
}
